import { render, staticRenderFns } from "./CvssScore.vue?vue&type=template&id=81d8b174&scoped=true"
import script from "./CvssScore.vue?vue&type=script&lang=js"
export * from "./CvssScore.vue?vue&type=script&lang=js"
import style0 from "./CvssScore.vue?vue&type=style&index=0&id=81d8b174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d8b174",
  null
  
)

export default component.exports